// Copied from https://github.com/final-form/react-final-form-listeners/blob/master/src/OnChange.js
// TODO: install react-final-form-listeners

import React from 'react';
import { Field } from 'react-final-form';

type Props = {
  children: (value: any, previous: any) => void;
  input: {
    value: any;
  };
};

type State = {
  previous: any;
};

class OnChangeState extends React.Component<Props, State> {
  // Copied from https://github.com/final-form/react-final-form-listeners/blob/master/src/OnChange.js
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      previous: props.input.value,
    };
  }

  componentDidUpdate() {
    const {
      children,
      input: { value },
    } = this.props;
    const { previous } = this.state;
    if (value !== previous) {
      this.setState({ previous: value });
      children(value, previous);
    }
  }

  render() {
    return null;
  }
}

export const OnChange = ({ name, children }: any) =>
  React.createElement(Field, {
    name,
    subscription: { value: true },
    allowNull: true,
    // Ignored until we refactor it to use Generic
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    render: (props) => React.createElement(OnChangeState, { ...props }, children),
  });
